import * as Sentry from '@sentry/browser';
import { pick } from 'lodash-es';
import { useState } from 'react';
import { BookingBuilderRequest, IHoldCheckReq, IHoldCheckResAccommodation, ITravelAgent, makeBackendApi } from 'services/BackendApi';

type UseHoldCheckAPI = {
  bookingBuilderRequest: BookingBuilderRequest;
  selectedTa?: ITravelAgent | null;
};

export const useHoldCheckAPI = (props: UseHoldCheckAPI) => {
  const [data, setData] = useState<IHoldCheckResAccommodation[] | null>(null);
  const [isLoading, setLoading] = useState<boolean>(false);

  const request = async (): Promise<IHoldCheckResAccommodation[] | null> => {
    const payload: IHoldCheckReq = {
      Accommodation: props.bookingBuilderRequest.Accommodation.map(x => ({
        ...pick(x, 'uuid', 'startDate', 'endDate', 'guestAges'),
      }))
    };

    const backendApi = makeBackendApi(props.selectedTa?.uuid);
    setLoading(true);

    try {
      const res = await backendApi.liveRatesHoldCheck(
        props.bookingBuilderRequest.hotelUuid,
        payload,
      );
      setData(res.data.data.Accommodation);
      return res.data.data.Accommodation;
    } catch (e) {
      console.error('Hold check failed:', e);
      Sentry.captureException(e);
      return null;
    } finally {
      setLoading(false);
    }
  };

  return {
    request,
    isLoading,
    data,
  };
};
